<template>
  <div
    :id="id"
    :class="`${isWizardPage ? 'wizard-page' : 'assessment-page'} ${
      disabled ? 'tw-opacity-50' : ''
    }`"
    class="tw-flex tw-items-start tw-justify-start tw-w-[fit-content] tw-flex-wrap"
  >
    <span class="tw-flex tw-items-center answer-box">
      <BaseCheckbox
        :text="textCheckboxLeft"
        :class="`${disabled ? 'tw-pointer-events-none' : ''}`"
        data-cy="base-checkbox-option-yes"
        :color="excluded || disabled ? '#DBDBDB' : colorCheckBox"
        :ticked="value === assessmentAnswerType1State.yes"
        :disabled="isTrue"
        :is-check-cursor="disabled"
        @selected="() => handleState(assessmentAnswerType1State.yes)"
        @unselected="() => handleState(assessmentAnswerType1State.unselected)"
      />
      <SuggestionButton
        v-if="suggestion === assessmentAnswerType1State.yes"
        :style="{
          visibility: onHover ? 'visible' : 'hidden',
        }"
        @on-clicked="handleState(assessmentAnswerType1State.yes)"
      />
    </span>
    <span class="tw-flex answer-box">
      <BaseCheckbox
        :text="textCheckboxRight"
        :color="excluded || disabled ? '#DBDBDB' : colorCheckBox"
        data-cy="base-checkbox-option-no"
        :disabled="isTrue"
        :is-check-cursor="disabled"
        :ticked="value === assessmentAnswerType1State.no"
        @selected="() => handleState(assessmentAnswerType1State.no)"
        @unselected="() => handleState(assessmentAnswerType1State.unselected)"
      />
      <SuggestionButton
        v-if="suggestion === assessmentAnswerType1State.no"
        :style="{
          visibility: onHover ? 'visible' : 'hidden',
        }"
        :css-style="'tw-bg-[linear-gradient(0deg,_rgba(254,_154,_5,_0.15)_0%,_rgba(254,_154,_5,_0.15)_100%)]'"
        @on-clicked="handleState(assessmentAnswerType1State.no)"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { Ref, onMounted, ref, watch } from "vue";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { assessmentAnswerType1State } from "@/utils/constants";
import SuggestionButton from "../common/suggestionButton.vue";
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  value: {
    type: [Number, String],
    default: null,
  },
  suggestion: {
    type: Number,
    default: null,
  },
  onHover: {
    type: Boolean,
    default: true,
  },
  isWizardPage: {
    type: Boolean,
    default: false,
  },
  isTrue: {
    type: [String, Number],
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  excluded: {
    type: Boolean,
    default: false,
  },
  colorCheckBox: {
    type: String,
    default: "#387DFF",
  },
  textCheckboxLeft: {
    type: String,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
    ),
  },
  textCheckboxRight: {
    type: String,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
    ),
  },
  id: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["onUpdate", "update:value"]);
// const state: Ref = ref(assessmentAnswerType1State.unselected);
const state: Ref = ref(props.isTrue);
const handleState = (value: number | string) => {
  if (props.disabled) return;
  if (props.value !== null && !state.value && !isMounted) return;
  state.value = value;
  emits("onUpdate", value);
  emits("update:value", value);
};

let isMounted = false;
onMounted(() => {
  setTimeout(() => {
    isMounted = true;
  }, 500);
});

watch(
  () => props.isTrue,
  (newValue, oldValue) => {
    if (newValue) {
      state.value = newValue;
      handleState(newValue);
    }
  },
  { deep: true },
);
</script>

<style lang="scss" scoped>
.wizard-page {
  gap: 60px;
  .answer-box {
    gap: 15px;
  }
}

.assessment-page {
  gap: 40px;
  .answer-box {
    gap: 10px;
  }
}
</style>
